import { getObjectFromLocalStore } from "./localStore";

const IS_NEW_DESIGN_KEY = "isNewDesign";

/**
 * Returns whether the new design/UI is enabled.
 * Checks localStorage for isNewDesign (boolean or "true"/"false" string).
 * Defaults to true when the key is not set.
 */
export function getIsNewDesign(): boolean {
  const raw = localStorage.getItem(IS_NEW_DESIGN_KEY);
  if (raw === null || raw === "") return true;
  const value = getObjectFromLocalStore(IS_NEW_DESIGN_KEY);
  return value === true || value === "true";
}

/** Enable or disable the new design flag in localStorage. */
export function setIsNewDesignEnabled(enabled = true): void {
  localStorage.setItem(IS_NEW_DESIGN_KEY, enabled ? "true" : "false");
}
